import React from "react"

import { AssessmentSubtitle, FullName } from "../../helper"

const AssessmentInfo = (props) => {
  const { assessmentData } = props;
  let firstName = assessmentData.assessmentInfo.firstName
  let lastName = assessmentData.assessmentInfo.lastName
  let currentYear = assessmentData.currentYear
  return (
    <div className="assessment-info">
      <div className="assessment-info-header">
        <span className="assessment-info-pupilName">{FullName(firstName, lastName)} </span>
      </div>
      <div className="assessment-info-header">
        <span className="assessment-info-pupilTitle">{AssessmentSubtitle(currentYear)} </span>
      </div>
    </div>
  )
}

export { AssessmentInfo }